module.exports = __webpack_public_path__ + "img/iRGD peptide.4d13c31c.png";